import React from 'react';
import { formatAmount } from '../../../lair/utils/missionMath';
import { missionName, rewardIcon, rewardName } from '../../../lair/utils/lairAssets';
import { useTranslation } from 'react-i18next';
import LifeLost from '../../common/LifeLost';

/** Final overlay: stars, cards on the foundations and rewards from the MissionRunDTO (same as Match3EndScreen). */
export default function SolitaireEndScreen({ result, stars = 0, foundation = 0, run, timedOut, onBack }) {
  const { t } = useTranslation();
  const win = result === 'WIN';
  const rewards = run?.rewards || [];
  const s = Math.max(0, Math.min(3, stars || 0));
  let headline = t('solitaire.end.dealer_wins', 'DEALER WINS');
  if (win) headline = foundation >= 52 ? t('solitaire.end.cleared', 'TABLE CLEARED') : t('solitaire.end.well_played', 'WELL PLAYED');
  if (timedOut) headline = t('game.end.times_up', "TIME'S UP");

  return (
    <div className={`sol-end ${win ? 'sol-end--win' : 'sol-end--lose'}`} role="dialog" aria-label={t('game.end.aria', 'Game result')} data-testid="end-screen">
      <div className="sol-end__card">
        <div className="sol-end__glow" />
        <div className="sol-end__headline">{headline}</div>
        {run?.missionName && <div className="sol-end__mission">{missionName(run, t)}</div>}
        <div className="sol-end__stars" aria-label={t('game.end.stars_aria', '{{n}} of 3 stars', { n: s })} data-testid="end-stars">
          {[0, 1, 2].map((i) => (
            <span key={i} className={`sol-end__star ${i < s ? 'is-on' : ''}`} style={{ animationDelay: `${0.25 + i * 0.2}s` }}>
              {i < s ? '★' : '☆'}
            </span>
          ))}
        </div>
        <div className="sol-end__score" data-testid="end-score">
          {foundation} <span>{t('solitaire.end.of_52', '/ 52 cards')}</span>
        </div>
        <div className="sol-end__sub">
          {win
            ? (s >= 3 ? t('solitaire.end.every_card', 'Every card in its place!') : t('solitaire.end.pays_out', 'The dealer pays out'))
            : (rewards.length
              ? t('solitaire.end.a_little', 'Your hero walked away with a little')
              : t('game.end.empty_handed', 'Your hero left empty-handed'))}
        </div>

        {rewards.length > 0 ? (
          <div className="sol-end__rewards" data-testid="end-rewards">
            {rewards.map((r, i) => {
              const icon = rewardIcon(r);
              return (
                <div key={`${r.rewardType}-${r.resourceCode || r.moduleId || ''}-${i}`} className="sol-reward">
                  <div className="sol-reward__icon">{icon ? <img src={icon} alt="" /> : <span>?</span>}</div>
                  <span className="sol-reward__name">{rewardName(r, t)}</span>
                  <span className="sol-reward__val">+{formatAmount(r.amount)}</span>
                </div>
              );
            })}
          </div>
        ) : (
          !run && <div className="sol-end__sub sol-end__sub--dim">{t('game.end.delivering', 'Rewards are being delivered…')}</div>
        )}

        {!win && <div><LifeLost /></div>}

        <button type="button" className="app-btn app-btn--green sol-end__btn" onClick={onBack}>
          {t('mission.back_to_lair', 'Back to Lair')}
        </button>
      </div>
    </div>
  );
}
